import React, { useEffect } from 'react';
import Swiper from 'react-id-swiper';
import { Row, Col } from 'reactstrap';
import classNames from 'classnames';
import { TimelineMax } from 'gsap';

import { Title } from 'components/typography';
import LearnMore from 'components/learnMore';
import ScrollAnimation from 'components/scrollAnimation';
import { SWIPER_SETTINGS, ANIMATION_SETTINGS } from 'config';

import {
  ourSolutionsOverview,
  description,
  solutionOptionsOuterContainer,
  solutionOptionsInnerContainer,
  carouselContainer,
  ourSolutionsContainer,
} from './scss/OurSolutions.module.scss';
import { AFEX_SOLUTIONS } from './OurSolutions.constants';
import SolutionCard from './SolutionCard';

const OurSolutions = () => {
  const timeline = new TimelineMax();
  useEffect(() => {
    timeline
      .staggerFromTo(
        '.slideInLeft',
        ANIMATION_SETTINGS.SLIDE_IN_RIGHT.DURATION * 1.25,
        ANIMATION_SETTINGS.SLIDE_IN_RIGHT.FROM,
        ANIMATION_SETTINGS.SLIDE_IN_RIGHT.TO,
        0.3
      )
      .fromTo(
        '.fadeIn',
        ANIMATION_SETTINGS.SLIDE_UP.DURATION * 2,
        ANIMATION_SETTINGS.SLIDE_UP.FROM,
        ANIMATION_SETTINGS.SLIDE_UP.TO,
        '-=0.8S'
      )
      .staggerFromTo(
        '.solutionIcon',
        ANIMATION_SETTINGS.SLIDE_UP.DURATION,
        ANIMATION_SETTINGS.SLIDE_UP.FROM,
        ANIMATION_SETTINGS.SLIDE_UP.TO,
        0.06,
        '-=0.6'
      )
      .staggerFromTo(
        '.solutionTitle',
        ANIMATION_SETTINGS.SLIDE_UP.DURATION,
        ANIMATION_SETTINGS.SLIDE_UP.FROM,
        ANIMATION_SETTINGS.SLIDE_UP.TO,
        0.06,
        '-=0.6'
      );
  }, []);

  return (
    <ScrollAnimation
      triggerElement=".ourSolutions"
      triggerHook="onEnter"
      tween={timeline}
      offset={100}
    >
      <div
        className={classNames('ourSolutions', ourSolutionsContainer)}
        name="ourSolutions"
      >
        <Row noGutters>
          <Col lg="5">
            <div className={ourSolutionsOverview}>
              <p className={classNames('slideInLeft', description)}>
                {`
                  Linking producers and consumers of commodities with a 
                  system that supports a fair exchange of value creates a 
                  trust economy where producers, processors and investors 
                  can fulfill their potential for increased productivity 
                  and wealth creation.
                `}
              </p>

              <Title
                value="We hold the keys to unlock this potential."
                size="lg"
                className="fadeIn"
              />

              <LearnMore
                context="AFEX SOLUTIONS"
                theme="white"
                arrowType="default"
                to="/market#products-and-services"
                className="slideInLeft"
              />
            </div>
          </Col>
          <Col lg="7" className={solutionOptionsOuterContainer}>
            <div className={solutionOptionsInnerContainer}>
              {AFEX_SOLUTIONS.map(solution => (
                <SolutionCard solution={solution} key={solution.id} />
              ))}
            </div>
          </Col>
        </Row>

        <div className={carouselContainer}>
          <Swiper {...SWIPER_SETTINGS}>
            {AFEX_SOLUTIONS.filter(solution => Boolean(solution.icon)).map(
              solution => (
                <div key={solution.id}>
                  <SolutionCard solution={solution} />
                </div>
              )
            )}
          </Swiper>
        </div>
      </div>
    </ScrollAnimation>
  );
};

OurSolutions.propTypes = {};

export default OurSolutions;
